import styled from 'particles/themes/styled'

export const SubmissionActionWrapper = styled.div`
    margin-top: 12px;
    display: flex;
    padding: 0px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[300]};
    align-self: stretch;
`

export const PostTimeContainer = styled.div`
    margin-bottom: 24px;

    .schedule-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        align-items: center;

        .action-button {
            min-width: fit-content;
        }
    }

    .date-range-input-container {
        width: 100%;

        .range-input-item {
            width: 100%;
        }

        .react-datepicker-wrapper {
            width: 100%;
            input {
                width: 100%;
                box-sizing: border-box;
            }
        }
    }
`
